import { useDispatch, useSelector } from "react-redux";
import type { HotelSortOptionEnum } from "@overrides/types";
import { useHotelListSortOptions } from "@tenant/hotels";
import { HotelsAvailabilityActions } from "../../../store";
import { getSort } from "../../../store/selectors";

export const useHotelListSort = () => {
  const dispatch = useDispatch();

  const selectedSort = useSelector(getSort);

  const handleSortChange = (value: string) => {
    dispatch(HotelsAvailabilityActions.setSort(value as HotelSortOptionEnum));
  };

  const sortOptions = useHotelListSortOptions();

  const getSortLabelKey = (sortOption: HotelSortOptionEnum): string =>
    sortOptions.find((option) => option.value === sortOption)?.shortLabel ?? "";

  return {
    context: {
      sortOptions,
      selectedSort,
    },
    handlers: {
      getSortLabelKey,
      handleSortChange,
    },
  };
};
